import { useEffect } from 'react';
import useIsLoggedIn from 'src/modules/authentication/hooks/useIsLoggedIn';
import { isWebView } from 'src/utils/platform';
import { Tab as TabElection } from 'tab-election';
import { initDataPruningService } from './DataPruningService';
import SyncBoxConfig from './SyncBoxConfig';
import SyncBoxFactory from './SyncBoxFactory';
import syncBoxManager from "./SyncBoxManager";
import dbListeners from './dbListeners';
import { imageCacheManager } from './image-cache/ImageCacheManager';
export default async function useInitSyncBoxManager() {
    const isLoggedIn = useIsLoggedIn();
    const initSyncBoxManager = async () => {
        await initDataPruningService();
        dbListeners.init();
        const configs = await SyncBoxConfig.getAllConfigs();
        const syncBoxes = configs.map(config => SyncBoxFactory.getInstance(config));
        await Promise.all(syncBoxes.map(syncBox => syncBoxManager.register(syncBox)));
        syncBoxManager.init();
        imageCacheManager.processPendingImages(true);
    };
    const destroySyncBoxManager = () => {
        syncBoxManager.destroy();
        dbListeners.destroy();
    };
    useEffect(() => {
        if (!isLoggedIn) {
            destroySyncBoxManager();
            return;
        }
        const init = async () => {
            if (isWebView) {
                await initSyncBoxManager();
            }
            else {
                try {
                    const tab = new TabElection('sync-box');
                    tab.waitForLeadership(async () => {
                        await initSyncBoxManager();
                    }).finally(() => {
                        destroySyncBoxManager();
                    });
                }
                catch (error) {
                    await initSyncBoxManager();
                }
            }
        };
        init();
    }, [isLoggedIn]);
}
